import { Account } from "callable-data-objects";
import React from "react";
import { Container, Divider, Header } from "semantic-ui-react";
import AccountSetting from "./AccountSetting";

type AccountVoiceClusterProps = {
  account: Account;
};

function AccountVoiceCluster({ account }: AccountVoiceClusterProps) {
  return (
    <Container>
      <Header as='h3'>Update Cluster Name</Header>
      <Divider />
      <AccountSetting
        account={account}
        name='VoiceCluster'
        type='clusterName'
        label='Cluster Name'
      />
      <Header as='h3'>Callable Version</Header>
      <Divider />
      <AccountSetting
        account={account}
        name='CallableVersion'
        type='callableVersion'
        label='Callable Version'
      />
    </Container>
  );
}

export default AccountVoiceCluster;
